import { render } from "./recebimento-coletor.vue?vue&type=template&id=57576e4d&scoped=true"
import script from "./recebimento-coletor.vue?vue&type=script&lang=js"
export * from "./recebimento-coletor.vue?vue&type=script&lang=js"

import "./recebimento-coletor.vue?vue&type=style&index=0&id=57576e4d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57576e4d"]])

export default __exports__